module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Dedication-rw",
    attrs: {
      "epub:type": "frontmatter dedication",
      "id": "Dedication1",
      "role": "doc-dedication"
    }
  }, [_c('div', {
    staticClass: "block-rw dedication-rw",
    attrs: {
      "id": "dedication1"
    }
  }, [_c('p', {
    staticClass: "ded-rw",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "p27"
    }
  }, [_c('span', [_c('span', [_c('em', [_vm._v("To Luke Bryan, Jason Aldean, and Keith Urban")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ded-rw",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "p28"
    }
  }, [_c('span', [_c('span', [_c('em', [_vm._v("for writing the kind of music that")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ded-rw",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "p29"
    }
  }, [_c('span', [_c('span', [_c('em', [_vm._v("inspires my kind of")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ded-rw",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "p30"
    }
  }, [_c('span', [_c('span', [_c('em', [_vm._v("stories.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10cf2000","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s003-Dedication-01.vue
// module id = 69
// module chunks = 0